import PrimaryButton from "./primary-button";

export default function Landing({ amount, onNext }) {
  return (
    <section className="su-hero">
      <h1 className="su-display">{amount ? `YOUR ${amount} IS READY!` : "YOU'RE ALMOST THERE."}</h1>
      <p className="su-hero-copy">Create a Stake Account to transfer it.</p>
      <PrimaryButton onClick={onNext}>Join 600,000 renters</PrimaryButton>
    </section>
  );
}
